import React, { useEffect, useRef, useState } from 'react';
import "@arcgis/core/assets/esri/themes/light/main.css";
import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import Graphic from "@arcgis/core/Graphic";
import esriRequest from "@arcgis/core/request";
import Home from "@arcgis/core/widgets/Home";
import ScaleBar from "@arcgis/core/widgets/ScaleBar.js";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery.js";
import Locate from "@arcgis/core/widgets/Locate.js";
import Expand from "@arcgis/core/widgets/Expand";
import Legend from "@arcgis/core/widgets/Legend";
import Search from "@arcgis/core/widgets/Search";
import Print from "@arcgis/core/widgets/Print";
import LayerList from "@arcgis/core/widgets/LayerList.js";
import Zoom from "@arcgis/core/widgets/Zoom";


import "@arcgis/core/assets/esri/themes/light/main.css"; // ArcGIS theme
// code for slider 
const mainLayerUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";

const adminSublayers = [
    { id: 1, title: "MP State", visible: false },
    { id: 3, title: "MP District", visible: true },
    { id: 94, title: "MP ULB", visible: true },
    { id: 95, title: "MP Ward", visible: false },
    { id: 5, title: "Municipal Area", visible: false },
    { id: 7, title: "Municipal Ward", visible: false },
];

// code for slider 
const PROPERTY_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";

const PROPERTY_SUBLAYERS = [
    { id: 14, title: "Property", visible: false },
    { id: 15, title: "Building Footprint", visible: false },
    { id: 16, title: "Builtup Area", visible: false },
    { id: 17, title: "Slum Area", visible: false },
    { id: 39, title: "Industrial Area", visible: false },
];

const SAMPDA_GUIDELINE_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/sampda_guideline/MapServer";
const SAMPDA_GUIDELINE_SUBLAYERS = [
    { id: 1, title: "Sampda Guideline 2025_26" },
];

// CSS HEADER 

const h4HeaderStyle = {
    margin: "16px 0 6px",
    color: "#0b0b0bff",
    background: "#cfd7deff",
    padding: "8px 12px",
    borderRadius: "6px",
    fontSize: "16px",
    cursor: "pointer",
    userSelect: "none",
    display: "flex",
    justifyContent: "space-between", // arrow on right
    alignItems: "center",
};

const subLayerRowStyle = {
    marginBottom: "6px", display: "flex",
    alignItems: "center", fontSize: "12px",
};
const lblName = {
    marginBottom: "6px",
    display: "flex",
    alignItems: "center",
    fontSize: "12px",
    userSelect: "none", cursor: "pointer",
    display: "flex", alignItems: "center", flexGrow: 1, fontSize: "12px",
};
// CSS HEADER 

// code for slider 
const LayerPanelPage = ({
    selectedDistrict,
    selectedUlb,
    selectedWard,
    districtCode,
    ulbCode,
    wardCode,
    activeTabinfo, dist_cd, ulb_cd, wardno, isRightSide,
    selectedTitle, activeTabRef, activeSubTabCard,view
}) => {
    const mapDiv = useRef(null);
    //const layerRef = useRef(null);
   // const [view, setView] = useState(null)

    const [activeTab, setActiveTab] = useState(activeTabinfo || 'total');



    //22 NOV LAyer reference 

    const layerRef = useRef(null);        // water layer
    const secondLayerRef = useRef(null);  // admin layer
    const legendWidgetRef = useRef(null);
    const [adminLegends, setAdminLegends] = useState({});
    const PropertierLayerRef = useRef(null);
    const [PropertyLegends, setPropertyLegends] = useState({});
    const sampdaGuidelineLayerRef = useRef(null);
    const [sampdaLegends, setSampdaLegends] = useState({});


    // code for expaned   8dec 2025
    const [showAdmin, setshowAdmin] = useState(false);
    const [showProperties, setshowProperties] = useState(false);
    const [showSampdaGuideline, setshowSampdaGuideline] = useState(false);
    const [checkedLayers, setCheckedLayers] = useState({});



    const subLayerRowStyle = {
        marginBottom: "6px", display: "flex",
        alignItems: "center", fontSize: "12px",
    };
    const lblName = {
        marginBottom: "6px",
        display: "flex",
        alignItems: "center",
        fontSize: "12px",
        userSelect: "none", cursor: "pointer",
        display: "flex", alignItems: "center", flexGrow: 1, fontSize: "12px",
    };




    //22 NOV LAyer reference 


    const buildFilter = (dist_cd, ulb_cd, wardno) => {
        const conditions = [];
        if (dist_cd) conditions.push(`dist_cd = '${dist_cd}'`);
        if (ulb_cd) conditions.push(`ulb_cd = '${ulb_cd}'`);
        if (wardno) conditions.push(`wardno = '${wardno}'`);
        return conditions.length > 0 ? conditions.join(" AND ") : "1=1";
    };
//remove this 2526
    // useEffect(() => {

    //     if (!mapDiv.current) return;

    //     const map = new Map({ basemap: "topo-vector" });

    //     const mapView = new MapView({
    //         container: mapDiv.current,
    //         map,
    //         center: [77.4126, 23.2599],
    //         zoom: 6,
    //         ui: { components: ["attribution"] }
    //     });

    //     const layer = new MapImageLayer({ url: mainLayerUrl, sublayers: [] });
    //     map.add(layer);
    //     layerRef.current = layer;
    //     //setView(mapView);

    //     mapView.ui.add(new Search({ view: mapView }), "top-left");
    //     mapView.ui.add(new Home({ view: mapView }), "top-left");
    //     mapView.ui.add(new Zoom({ view: mapView }), "top-left");
    //     mapView.ui.add(new Expand({ view: mapView, content: new BasemapGallery({ view: mapView }) }), "top-left");
    //     mapView.ui.add(new Locate({ view: mapView, graphic: new Graphic({ symbol: { type: "simple-marker" } }) }), "top-left");
    //     mapView.ui.add(new ScaleBar({ view: mapView }), "bottom-right");

    //     mapView.when(() => {
    //         const printWidget = new Print({
    //             view: mapView,
    //             printServiceUrl: "https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task"
    //         });

    //         const expandPrint = new Expand({
    //             view: mapView,
    //             content: printWidget
    //         });

    //         mapView.ui.add(expandPrint, "top-left");

    //         // ✅ Add and attach legend
    //         const legendWidget = new Legend({
    //             view: mapView,
    //             style: "classic"
    //         });

    //         const legendExpand = new Expand({
    //             view: mapView,
    //             content: legendWidget,
    //             expanded: false
    //         });

    //         mapView.ui.add(legendExpand, "top-left");
    //         legendWidgetRef.current = legendWidget;
    //     });

    //     //  legend  layerList

    //     const layerList = new LayerList({
    //         view: mapView
    //     });

    //     const expand = new Expand({
    //         view: mapView,
    //         content: layerList,
    //         expanded: false
    //     });
    //     //Layer LIST BLOCK
    //     // mapView.ui.add(expand, "top-left");


    //     // code  end  for legend  




    //     return () => {
    //         if (mapView) {
    //             mapView.destroy();
    //         }
    //     };
    // }, []);
useEffect(() => {
    if (view && mapDiv.current) {
        view.container = mapDiv.current;
    }
}, [view]);

    useEffect(() => {
        if (view && layerRef.current && activeTabinfo) {
            setActiveTab(activeTabinfo);
            handleTabClick(activeTabinfo);
        }
    }, [view, activeTabinfo, selectedTitle]);

    useEffect(() => {
        if (layerRef.current) {
            const filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
            layerRef.current.sublayers.forEach(sublayer => {
                sublayer.definitionExpression = filterExpr;
            });

        }
    }, [dist_cd, ulb_cd, wardno]);


    const fetchLegendALL = async (url, setLegendState) => {
        try {
            const response = await esriRequest(`${url}/legend`, {
                query: { f: "json" },
                responseType: "json"
            });

            const legends = {};
            response.data.layers.forEach((layer) => {
                const item = layer.legend?.[0];
                if (item && item.imageData) {
                    legends[layer.layerId] = {
                        label: item.label,
                        image: `data:${item.contentType};base64,${item.imageData}`
                    };
                }
            });

            setLegendState(legends);
        } catch (error) {
            console.error("Error fetching legend for:", url, error);
        }
    };


    //METHODSCALL FOR ADMIN
    useEffect(() => {
        fetchLegendALL(mainLayerUrl, setAdminLegends);
        fetchLegendALL(PROPERTY_URL, setPropertyLegends);
        fetchLegendALL(SAMPDA_GUIDELINE_URL, setSampdaLegends);

    }, []);


    // activeTab  6 JAN 2026  Code for Active operlayers step two  end 


    useEffect(() => {
        const initial = {};
        // ADMIN LAYERS
        adminSublayers.forEach((s) => {
            initial[`admin-${s.id}`] = s.id === 1 || s.id === 3;
        });
        /* ----------   PROPERTY TAB ---------- */

        PROPERTY_SUBLAYERS.forEach((s) => {
            initial[`property-${s.id}`] = activeTab === "property";
        });
        /* ----------WATER TAB  ---------- */

        setCheckedLayers((prev) => ({
            ...prev,
            ...initial,
        }));
    }, [activeTab, selectedTitle]);


    //Admin ACTION
    const toggleAllAdmin = (isChecked) => {
        adminSublayers.forEach((s) => {

            handleToggleSublayer(
                secondLayerRef,
                "admin",
                s.id,
                isChecked
            );
        });
    };

    //PROPERTY ACTION
    const toggleAllProperty = (isChecked) => {
        PROPERTY_SUBLAYERS.forEach((s) => {
            handleToggleSublayer(
                PropertierLayerRef,
                "property",
                s.id,
                isChecked
            );
        });
    };
    //    SAMPDA_GUIDELINE_SUBLAYERS  sampdaGuidelineLayerRef,

    const toggleAllSampda = (isVisible) => {
        SAMPDA_GUIDELINE_SUBLAYERS.forEach((s) => {
            handleToggleSublayer(
                sampdaGuidelineLayerRef, // MapImageLayer ref
                "sampda",       // group key
                s.id,
                isVisible
            );
        });
    };

    // CODE FOR ONE BY ONE CHECKED

    const handleToggleSublayer = (
        layerRef,
        groupKey,     // "admin" | "property" | "water" | "storm" | etc
        sublayerId,
        isVisible
    ) => {
        // 1️⃣ Toggle ArcGIS sublayer
        const sublayer = layerRef.current?.allSublayers?.find(
            (s) => s.id === sublayerId
        );

        if (sublayer) {
            sublayer.visible = isVisible;
        }

        // 2️⃣ Save checkbox state (React)
        const stateKey = `${groupKey}-${sublayerId}`;
        setCheckedLayers((prev) => ({
            ...prev,
            [stateKey]: isVisible
        }));
    };


    const handleTabClick = (key) => {
        setActiveTab(key);

        if (view && layerRef.current) {
            // view.graphics.removeAll();
            // view.map.removeAll();
            loadLayers(key);
        }
    };


    // 22 NOV 2025 code for load others Layer
    const loadLayers = (key) => {

        let filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
        filterExpr = buildFilter(dist_cd, ulb_cd, wardno);

        // code for defualt ADMIN LAYER

        const adminLayerDefualt = new MapImageLayer({
            url: mainLayerUrl,
            sublayers: adminSublayers.map((s) => ({
                id: s.id,
                title: s.title,
                visible: s.id === 1 || s.id === 3, // ✅ only these two ON
            })),
        });
        secondLayerRef.current = adminLayerDefualt;
        view.map.add(adminLayerDefualt);

        // code for defualt ADMIN LAYER
        const adminLayer = new MapImageLayer({
            url: mainLayerUrl,
            sublayers: adminSublayers.map((s) => ({
                id: s.id,
                title: s.title,
                visible: false
            }))
        });
        secondLayerRef.current = adminLayer;
        view.map.add(adminLayer);

        // alert(key);
        if (key === "property") {

            // Add PROPERTY_SUBLAYERS PROPERTY_URL
            const PROPERTY_layer = new MapImageLayer({
                url: PROPERTY_URL,
                sublayers: PROPERTY_SUBLAYERS.map((s) => ({
                    id: s.id,
                    title: s.title,
                    visible: true,
                    definitionExpression: filterExpr
                }))
            });
            PropertierLayerRef.current = PROPERTY_layer;
            view.map.add(PROPERTY_layer);

            // code for Property 

        }// if end 

        else {

            // Add PROPERTY_SUBLAYERS PROPERTY_URL
            const PROPERTY_layer = new MapImageLayer({
                url: PROPERTY_URL,
                sublayers: PROPERTY_SUBLAYERS.map((s) => ({
                    id: s.id,
                    title: s.title,
                    visible: false,
                    definitionExpression: filterExpr
                }))
            });
            PropertierLayerRef.current = PROPERTY_layer;
            view.map.add(PROPERTY_layer);

            // code for Property 
        }

        // Add Sampda Guideline Layer
        filterExpr = buildFilter(dist_cd, ulb_cd, wardno);
        const sampdaGuidelineLayer = new MapImageLayer({
            url: SAMPDA_GUIDELINE_URL,
            sublayers: SAMPDA_GUIDELINE_SUBLAYERS.map((s) => ({
                id: s.id,
                title: s.title,
                visible: false,
                definitionExpression: filterExpr
            }))
        });
        sampdaGuidelineLayerRef.current = sampdaGuidelineLayer;
        view.map.add(sampdaGuidelineLayer);
        // Add Sampda Guideline Layer


    }
    // code end legends

    useEffect(() => {
        if (!view) return;
        view.graphics.removeAll();
        handleTabClick(activeTabinfo);
    }, [view]);


    return (
        <div>
            <div>
                <h4
                    style={{
                        margin: "0 0 10px",
                        background: "linear-gradient(to right, #047c6eff, #03816cff)",
                        color: "#041836ff",
                        borderRadius: "6px",
                        fontSize: "20px",
                        textAlign: "center"
                    }}
                >
                    <b style={{ color: "#f0f2f5ff", }}>    All Layer Control
                    </b>
                </h4>


                {/* ========= Admin Layers ========= */}
                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={adminSublayers.every(
                                    (s) => checkedLayers[`admin-${s.id}`]
                                )}
                                onChange={(e) => toggleAllAdmin(e.target.checked)}
                                style={{ display: "none" }}
                            />

                            {/* CUSTOM CHECKBOX UI */}
                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: adminSublayers.every(
                                        (s) => checkedLayers[`admin-${s.id}`]
                                    )
                                        ? "#4a8dc1ff"
                                        : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {adminSublayers.every(
                                    (s) => checkedLayers[`admin-${s.id}`]
                                ) && "✓"}
                            </span>
                        </label>

                        {/* 👇 TEXT IS NOW PERFECTLY LEFT ALIGNED */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowAdmin(!showAdmin)}
                        >
                            Admin Layers
                        </span>
                    </div>

                    {/* RIGHT SIDE (ARROW) */}
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setshowAdmin(!showAdmin)}
                    >
                        {showAdmin ? "▲" : "▼"}
                    </span>
                </h4>


                {showAdmin && (
                    <div>
                        {adminSublayers.map((s) => {
                            const key = `admin-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    secondLayerRef,   // MapImageLayer ref
                                                    "admin",          // group key
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {PropertyLegends[s.id] && (
                                        <img src={PropertyLegends[s.id].image}
                                            alt={PropertyLegends[s.id].label}
                                            style={{ marginLeft: "8px", width: "24px", height: "24px" }}
                                        />
                                    )}

                                </div>
                            );
                        })}
                    </div>
                )}

                {/* ========= PROPERTIES ========= */}


                <h4 style={h4HeaderStyle}>
                    {/* LEFT SIDE */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {/* MASTER CHECKBOX */}
                        <label
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                display: "inline-flex",
                                cursor: "pointer",
                                gap: "6px",
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={PROPERTY_SUBLAYERS.every(
                                    (s) => checkedLayers[`property-${s.id}`]
                                )}
                                onChange={(e) => toggleAllProperty(e.target.checked)}
                                style={{ display: "none" }}
                            />

                            {/* CUSTOM CHECKBOX UI */}
                            <span
                                style={{
                                    width: "20px",
                                    height: "20px",
                                    border: "2px solid #333",
                                    borderRadius: "3px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: PROPERTY_SUBLAYERS.every(
                                        (s) => checkedLayers[`property-${s.id}`]
                                    )
                                        ? "#4a8dc1ff"
                                        : "#fff",
                                    color: "#fff",
                                    fontSize: "16px",
                                }}
                            >
                                {PROPERTY_SUBLAYERS.every(
                                    (s) => checkedLayers[`property-${s.id}`]
                                ) && "✓"}
                            </span>
                        </label>

                        {/* 👇 LEFT-ALIGNED TEXT */}
                        <span
                            style={{ cursor: "pointer", fontWeight: "600" }}
                            onClick={() => setshowProperties(!showProperties)}
                        >
                            Properties
                        </span>
                    </div>

                    {/* RIGHT SIDE ARROW */}
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setshowProperties(!showProperties)}
                    >
                        {showProperties ? "▲" : "▼"}
                    </span>
                </h4>


                {showProperties && (
                    <div>
                        {PROPERTY_SUBLAYERS.map((s) => {
                            const key = `property-${s.id}`;

                            return (
                                <div key={s.id} style={subLayerRowStyle}>
                                    <label style={lblName}>
                                        <input
                                            type="checkbox"
                                            checked={!!checkedLayers[key]}
                                            onChange={(e) =>
                                                handleToggleSublayer(
                                                    PropertierLayerRef, // MapImageLayer ref
                                                    "property",         // group key
                                                    s.id,
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        <span style={{ marginLeft: "8px" }}>{s.title}</span>
                                    </label>

                                    {PropertyLegends[s.id] && (
                                        <img src={PropertyLegends[s.id].image}
                                            alt={PropertyLegends[s.id].label}
                                            style={{ marginLeft: "8px", width: "24px", height: "24px" }}
                                        />
                                    )}

                                </div>
                            );
                        })}
                    </div>
                )}



            </div>

            <div
                ref={mapDiv}
                style={{
                    marginTop: "5%",
                    width: "100%",
                    borderRadius: "4px"
                }}
            />
        </div>
    );
};

export default LayerPanelPage;
